import { FleekError } from './FleekError';

type ProjectFleekFunctionLimitExceededErrorOptions = Record<string, never>;

export class ProjectFleekFunctionLimitExceededError extends FleekError<ProjectFleekFunctionLimitExceededErrorOptions> {
  public name = 'ProjectFleekFunctionLimitExceededError';

  constructor() {
    super({});
  }

  toString = () =>
    `You've reached the maximum number of Fleek functions for this project. Contact our Support team if you have any questions.`;
}
